import { LegalPage } from "@/components/LegalPage";
import { trackEmailClick, trackPhoneClick } from "@/lib/analytics";

const Impressum = () => (
  <LegalPage title="Impressum" path="/impressum">
    <h2>Angaben gemäß § 5 DDG</h2>
    <address>
      <p>
        Clicks DMP – Design &amp; Media Production
        <br />
        Inhaber: Ashraf AlSalaita
        <br />
        Karl-Traub-Straße 15
        <br />
        68199 Mannheim
        <br />
        Deutschland
      </p>
    </address>

    <h2>Kontakt</h2>
    <p>
      Telefon:{" "}
      <a href="tel:+4917670027200" onClick={() => trackPhoneClick()}>
        +49 176 700 27 200
      </a>
      <br />
      E-Mail:{" "}
      <a href="mailto:info@clicksdmp.com" onClick={() => trackEmailClick()}>
        info@clicksdmp.com
      </a>
    </p>

    <h2>Umsatzsteuer-Identifikationsnummer</h2>
    <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: DE412576631</p>

    <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
    <p>Ashraf AlSalaita, Karl-Traub-Straße 15, 68199 Mannheim</p>

    <h2>Verbraucherstreitbeilegung</h2>
    <p>
      Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
      Verbraucherschlichtungsstelle teilzunehmen.
    </p>

    <h2>Bildnachweise</h2>
    <p>Fotos und Videos auf dieser Website: Clicks DMP, sofern nicht anders angegeben.</p>
  </LegalPage>
);

export default Impressum;
